﻿'use strict';

/**
* Controller for the log in
* @memberOf components.authenticationModule
* @namespace logInController
*/

logInController.$inject = ['authenticationFactory', 'authorizationFactory', '$state', 'sessionManagementFactory', 'connectionsFactory', 'data_project_constants'];

function logInController(authenticationFactory, authorizationFactory, $state, sessionManagementFactory, connectionsFactory, data_project_constants) {
    /* jshint validthis:true */
    var vm = this;
    vm.oktaIdExistsInLegacyAccount = null;

    vm.isBrowserCompatible = authenticationFactory.isBrowserCompatible(global);

    vm.init = function () {
        if (authenticationFactory.oktaAuthClient.token.isLoginRedirect()) {
            authenticationFactory.parseOktaTokens()
                .then(function (result) {
                    authenticationFactory.oktaAuthClient.tokenManager.add('idToken', result.tokens.idToken);
                    authenticationFactory.oktaAuthClient.tokenManager.add('accessToken', result.tokens.accessToken);

                    vm.apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);

                    vm.apiConnection
                        .all('userInfo/hasOktaIdentity')
                        .customGET()
                        .then(function (result) {
                            vm.oktaIdExistsInLegacyAccount = result.hasOktaIdentity;

                            if (vm.oktaIdExistsInLegacyAccount) {
                                authorizationFactory.setProfessorRole()
                                    .then(function () {
                                        // Directly assigning URL instead of moving to defined stateProvider.state 
                                        // as a workaround to remove Okta authentication response added to URL query string
                                        // Otherwise the query string persists and incorrectly shows the app as being in 
                                        // a callback state from Okta even though we have processed the auth response via parseOktaTokens()
                                        if (authorizationFactory.authorizeProfessor()) {
                                            window.location.assign('/#!/dataRights');
                                        }
                                        else {
                                            window.location.assign('/#!/admin');
                                        }
                                    })
                                    .catch(function (error) {
                                        console.error('Failed to retrieve roles for user: ', error);
                                    });
                            }
                        })
                        .catch(function (response) {
                            console.log('Failed to look up user Okta identity: ' + response);
                            vm.oktaIdExistsInLegacyAccount = false;
                        })
                })
                .catch(function (error) {
                    console.error("Failed to process Okta redirect response: " + error);
                });
        }
        else {
            authenticationFactory.authenticateWithOkta();
        }
    }

    vm.init();
}

module.exports = logInController;



//////////////////
// WEBPACK FOOTER
// ./source/angular/components/authentication/logInController.js
// module id = 20
// module chunks = 0